<template>
	<div>
		<topbar></topbar>
		<sortHeader></sortHeader>
		<heardernav></heardernav>
		<div class="border p20 container_outer">
			<div class="box-h4">
				<h4 class="left">Receiving address management</h4>
			</div>
			<div class="clr"></div>
			<div class="mt20">
				<input  v-if="canCreateAddress" type="button" class="hq-btn-6 mr15" value="Add address" @click="toAddressDetail()">
				<form>
					<table class="table-c-5" width="100%" border="0" cellspacing="0" cellpadding="0">
						<tbody>
							<tr>
								<th style="width:60px;padding-right: 15px;text-align: left;">Consignee</th>
								<th style="width:80px;padding-right: 15px;text-align: left;">Area</th>
								<th style="width:100px;padding-right: 15px;text-align: left;">Detailed address</th>
								<th style="width:60px;padding-right: 15px;text-align: left;">Postal code</th>
								<th style="width:70px;padding-right: 15px;text-align: left;">Contact Phone</th>
								<th style="width:70px;padding-right: 15px;text-align: left;">Action</th>
								<th style="width:70px;padding-right: 15px;text-align: left;"> </th>
							</tr>
							<tr v-for="(bo,index) in boList"  @mouseenter="addressShow(index)" @mouseleave="addressHide()">
								<td>
									{{ bo.contextName }}
								</td>
								<td>
									{{ bo.province }}{{ bo.city }}{{ bo.district }}
								</td>
								<td>
									{{ bo.address }}
								</td>
								<td>
									{{ bo.zipcode }}
								</td>
								<td>
									{{ bo.mobile }}
								</td>
								<td>
									<a class="change_a" @click="toAddressDetail(bo.id)">Modify</a>  |  <a class="delete_a" @click="deleteAddress(bo.id,index)">delete</a>
								</td>
								<td>
									<span  class="note" v-if="bo.isDefault=='y'">Default address</span>
									
									<input  v-if="addressIndex == index && bo.isDefault=='n'" type="button" class="tbl-deliver-address" value="Set as Default" @click="setDefaultAddress(bo.id,index)">
								</td>
							</tr>
							
						</tbody>
						
					</table>
				</form>
				
			</div>
		</div>
		<footermenu></footermenu>
		<footercopyright></footercopyright>
	</div>
</template>
<script>
	//import jQuery from "../../../static/js/jquery.min.js"
	import jQuery from 'jquery';
	import API from "../../../static/api/api.js"
	import {parseResult} from "../../../static/js/emallUtils.js"
	import alertConfirm from "../../../static/js/alertConfirm.js"
	import Vue from 'vue'
	import TopBar from '@/components/TopBar'
	import Header from '@/components/Header'
	import FooterMenu from '@/components/FooterMenu'
	import FooterCopyright from '@/components/FooterCopyright'
	import HearderNav from '@/components/HearderNav'
    export default {
    	name: 'address_list',
        data(){
            return {
            	goodsCode:'',
            	goodsCodes:'',
            	payNum:'',
            	boList:[],
            	addressTitle:'Receiving address management',
            	sourceUrl:'',
            	cityInfo: '',
            	backUrl:'address_list',
            	orderSource:'',
            	canCreateAddress:true,
            	addressIndex:''
            }
        },
        components: {
        	'topbar':TopBar,
        	'sortHeader':Header,
	        'footermenu':FooterMenu,
			'footercopyright':FooterCopyright,
			'heardernav':HearderNav
        },
        methods:{
        	addressShow:function(index){
        		this.addressIndex = index;
        	},
        	addressHide:function(){
        		this.addressIndex = -1;
        	},
        	queryUserAddress:function(){
        		var that = this;
        		API.queryUserAddress(function(ret){
        			if(ret.code == "success"){
        				that.boList = ret.data;
        				if(that.boList!=null&&that.boList.length>4){
							that.canCreateAddress=false;
						}
        			}
        		});
        	},
        	setDefaultAddress:function(addressId,index){
        		var that = this;
        		API.setDefaultAddress(addressId,function(ret){
        			if(ret.code == "success"){
        				that.addressIndex=index;
        				if(that.boList!=null){
							for(var i=0;i<that.boList.length;i++){
								that.boList[i].isDefault='n';
							}
						}
        				that.boList[index].isDefault='y';
        				//alertConfirm.singleConfirm('Set default address success!');
        			}
        		});
        	},
        	deleteAddress:function(addressId,index){
        		var that = this;
        		API.deleteAddress(addressId,function(ret){
        			if(ret.code == "success"){
        				that.boList.splice(index, 1);
        				if(that.boList!=null&&that.boList.length<5){
							that.canCreateAddress=true;
						}
        				alertConfirm.singleConfirm('delete address succeeded');
        			}else if(ret.code == "addressNotExists"){
        				alertConfirm.singleConfirm('Address information does not exist');
        			}else if(ret.code == "addressUserError"){
        				alertConfirm.singleConfirm('There is no right to delete this address information');
        			}
        		});
        	},
        	toAddressDetail:function(addressId){
				this.$router.push({ name: 'address', 
				query:{
					backUrl:'address_list',
					addressId:addressId
				}}
				);
		  	}
        	 
        },
        beforeMount:function(){
        		
        },
		mounted(){
			window.scrollTo(0, 0);
			this.queryUserAddress();
		}
    }
</script>

<style scoped>
.p20 {
    padding: 20px;
}
.border {
    background: #fff;
    border: solid 1px #dddddd;
}
.box-h4 {
    padding-bottom: 10px;
}
.left {
    float: left;
}
.clr {
    clear: both;
    font-size: 0px;
    zoom: 1;
}
.mt20 {
    margin-top: 20px;
}
.table-c-5 th {
    text-align: right;
    padding: 0 10px;
    background: #f9f9f9;
    border: solid 1px #ddd;
}
.table-c-5 th, .table-c-5 td {
    font-weight: normal;
    padding: 10px 3px;
    height: 23px;
    border: solid 1px #eee;
    border-width: 1px 0 1px 0;
}
.Table_1 td {
	padding: 10px 10px;
	color: #666;
}

.Table_1 tr {
	border-bottom: 1px solid #eee;
}

.Table_1 tr:hover {
	background: #e1e1e1;
}

.Table_1 tr:hover i {
	display: block;
}

.Table_1 tr.Table_1_Tr1:hover {
	background: #eee;
}

.Table_1 tr td i {
	display: none;
	font-style: normal;
	background: #ff6600 none repeat scroll 0 0;
	color: #fff;
	padding: 6px 5px;
	float: left;
	border-radius: 5px;
	cursor: pointer;
}
.Table_1 tr td i a {
	color: #fff;
	text-align: center;
	width: 105px;
}
.container_outer{
	height: 80%;
    width: 80%;
    //margin-left: 10%;
    margin-top: 30px;
    padding-left: 10%;
        border: solid 1px #ddd;
}
.submit_button{
	padding: 5px 30px;
	border: solid 1px #bdb3b3;
}
.change_a {
    color: #36c;
}
.delete_a {
    color: #f00;
}
.table {
    table-layout: fixed;
    border: solid 1px #ddd;
}
.hq-btn-6 {
    padding: 6px 18px;
    margin: 10px;
    color: #fff;
    background: #f60;
    border-radius: 5px;
    cursor: pointer;
}
.note {
    padding: 2px 5px;
    border-color: #ff3800;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    background: #ffd6cc;
    color: #f30;
}

.tbl-deliver-address {
    padding: 2px 5px;
    background: #f60;
    color: #fff;
    /*border: 1px solid #f60;*/
    border-radius: 3px;
    text-decoration: none;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/page/address/address_list.vue